module.exports = __webpack_public_path__ + "img/attachment-google-drive.a267f3ec.svg";